import React from 'react';

export const Badge: React.FC<{ 
  children: React.ReactNode; 
  color?: 'green' | 'blue' | 'purple' | 'red' | 'gray' | 'yellow';
  className?: string;
}> = ({ children, color = 'blue', className = '' }) => {
  const colors = {
    green: "bg-green-100 text-green-800",
    blue: "bg-[#2f5c96]/10 text-[#2f5c96]",
    purple: "bg-[#c19cca]/20 text-[#2f5c96]",
    red: "bg-red-100 text-red-800",
    gray: "bg-gray-100 text-gray-800",
    yellow: "bg-yellow-100 text-yellow-800"
  };
  return (
    <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold ${colors[color]} ${className}`}>
      {children}
    </span>
  );
};